// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"f0352db3","112":"a5980b36","200":"dbcdc1ac","301":"ad164c76","370":"4dcf24e9","412":"003db401","436":"f8c76ea5","487":"0d9c9e05","537":"1dc0305a","631":"722e982f","921":"2d82a207","958":"8d1354af","986":"c42752fe"}[chunkId] + ".chunk.js";
};